'use strict'
import {researchIntegrationUpdateScrollBoxClasses, researchIntegrationEnableScrollboxes} from './js/research-integration/enable-scrollboxes';
import researchIntegrationCreateNavAndAnchors from './js/research-integration/create-research-nav-and-anchors';

export default {
  researchIntegrationCreateNavAndAnchors: researchIntegrationCreateNavAndAnchors,
  researchIntegrationUpdateScrollBoxClasses: researchIntegrationUpdateScrollBoxClasses,
  researchIntegrationEnableScrollboxes: researchIntegrationEnableScrollboxes
};